import type { ReactNode } from 'react'
import { useState } from 'react'
import { ApplicantModal } from '~/components/Scopes/Applicants/ApplicantModal/ApplicantModal'
import type { ApplicantModalType } from '~/types/global'
import { ApplicantModalContext } from '~/utils/contextes'

export function ApplicantModalProvider({ children }: { children: ReactNode }) {
  const [applicantCollection, setApplicantCollection] = useState<
    ApplicantModalType[]
  >([])
  const [applicantCurrentId, setApplicantCurrentId] = useState<number | null>(
    null
  )
  const [openNextAction, setOpenNextAction] = useState(false)

  return (
    <ApplicantModalContext.Provider
      value={{
        applicantCollection,
        setApplicantCollection,
        applicantCurrentId,
        setApplicantCurrentId,
        openNextAction,
        setOpenNextAction
      }}
    >
      {children}
      {applicantCurrentId && (
        <ApplicantModal
          defaultApplicantId={applicantCurrentId}
          collection={applicantCollection}
          openNextAction={openNextAction}
          onClose={() => {
            setApplicantCurrentId(null)
            setOpenNextAction(false)
          }}
        />
      )}
    </ApplicantModalContext.Provider>
  )
}
